<script setup>
import {computed, onMounted} from 'vue'
import { useFacilityStore } from '@/stores/facility.js'
import { useRoute } from 'vue-router'
import Split from '@/layouts/split.vue'
import Comments from '@/components/Comments.vue'
import FacilityDetails from "@/components/facility/FacilityDetails.vue";
import WorksList from "@/components/work/WorksList.vue";
import OrganizationList from "@/components/customer/OrganizationList.vue";
import ContractsList from "@/components/contract/ContractsList.vue";

const route = useRoute()
const facilityStore = useFacilityStore()
const facility = computed(() => facilityStore.facility)

onMounted(() => {
  facilityStore.loadFacility(route.params.id);
});

const facilityId = route.params.id;
</script>
<template>
  <Split>
    <template #main>
      <FacilityDetails :facility-id="facilityId" />
      <div class="flex gap-4 pt-4 flex-col lg:flex-row">
        <div class="flex flex-col gap-4 w-full lg:w-2/5">
          <OrganizationList :facility-id="Number(facilityId)"/>
          <ContractsList :facility-id="Number(facilityId)" :rows-per-page="2" />
        </div>
        <WorksList :facility-id="Number(facilityId)" class="w-full lg:w-3/5"/>
      </div>
    </template>


    <template #sidebar>
      <Comments
          class="flex-1 min-h-0"
          target="facility"
          :entity-id="route.params.id"
          :currentUserName="'Вы'"
      />
    </template>
  </Split>

</template>